import { useParams } from "react-router-dom";
import {
  Photo,
  Video,
  Trivia,
  MultipleChoice,
  Sticker,
  QRCode,
  Background,
  Text,
} from "../types";

const TypeSection = ({ useQuery }) => {
  const { id, task_type } = useQuery();
  const { game_id } = useParams();

  switch (task_type?.toString()) {
    case "1":
    default:
      return <Photo />;
    case "2":
      return <Video useQuery={useQuery} />;
    case "5":
      return <Trivia useQuery={useQuery} />;
    case "6":
      return <MultipleChoice useQuery={useQuery} />;
    case "3":
      return <Sticker useQuery={useQuery} />;
    case "4":
      return <QRCode useQuery={useQuery} game_id={game_id} id={id} />;
    case "9":
      return <Background useQuery={useQuery} />;
    case "10":
      return <Background useQuery={useQuery} />;
    case "0":
      return <Text />;
  }
};

export default TypeSection;
